const routes = [
  {
    path: '/deviceMg',
    name: 'deviceMg',
    component: () => import('./pages/Home'),
    redirect: '/deviceMg/carameGroup',
    meta: {
      requireAuth: false
    },
    children: [
      {
        // 设备管理-摄像机分组
        path: 'carameGroup',
        name: 'carameGroup',
        component: () => import('./pages/Index'),
        meta: {
          requireAuth: false
        }
      }
    ]
  }
]
export default routes